import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';  // Agregar esta importación
import { endpoints } from '../config/apiConfig';  // Agregar esta línea
import Swal from 'sweetalert2'; // Agregar al inicio del archivo con los otros imports

const VerMatricula = () => {
  const navigate = useNavigate();
  const [materias, setMaterias] = useState([]);
  const [programaInfo, setProgramaInfo] = useState({ codigo: '', nombre: '' });
  const [loading, setLoading] = useState(true);
  const [acuerdo, setAcuerdo] = useState('');
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [observacion, setObservacion] = useState('');
  const [isSending, setIsSending] = useState(false);
  const handleSubmit = async (estado) => {
    try {
      setIsSending(true);
      const documento = localStorage.getItem('documento');
      
      const requestBody = {
        cedula: documento,
        estado: estado,
        periodo_id: 2,
        observacion: estado === 1 ? "Las materias son correctas" : observacion.trim()
      };
      
      const response = await fetch(endpoints.validarMaterias, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });
      
      const data = await response.json();
      
      if (response.ok) {
        await Swal.fire({
          icon: 'success',
          title: estado === 1 ? '¡Aprobado!' : 'Rechazado',
          text: estado === 1 
            ? 'Las materias están aprobadas correctamente' 
            : 'Las materias han sido rechazadas',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Aceptar'
        });
        setShowModal(false);
      } else {
        throw new Error(data.message || `Error del servidor: ${response.status}`);
      }
    } catch (error) {
      console.error('Error:', error);
      await Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `Error: ${error.message}`,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Cerrar'
      });
    } finally {
      setIsSending(false);
    }
  };
  const handleAcuerdoChange = (valor) => {
    setAcuerdo(valor);
    setError('');
    if (valor === 'acepto') {
      handleSubmit(1);
    } else {
      setShowModal(true);
    }
  };
  const handleObservacionSubmit = () => {
    if (observacion.trim() === '') {
      Swal.fire({
        icon: 'warning',
        title: 'Campo requerido',
        text: 'Por favor, ingrese una observación',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar'
      });
      return;
    }
    handleSubmit(0);
  };
  // Luego el useEffect
  useEffect(() => {
    const fetchMaterias = async () => {
      try {
        const documento = localStorage.getItem('documento');
        if (!documento) {
          navigate('/login');
          return;
        }
  
        const response = await fetch(endpoints.materias(documento));
        if (!response.ok) throw new Error('Error al obtener materias');
        
        const data = await response.json();
  
        if (!data.existe) {
          throw new Error('No se encontraron materias para este estudiante');
        }
  
        setProgramaInfo({
          codigo: data.programa.cod_programa,
          nombre: data.programa.programa
        });
  
        const materiasFormateadas = data.programa.materias.map((item, index) => ({
          numero: index + 1,
          nombre: item.materia,
          grupo: item.grupo
        }));
  
        setMaterias(materiasFormateadas);
      } catch (error) {
        console.error('Error:', error);
        setError('Error al cargar las materias');
        setTimeout(() => navigate('/login'), 3000);
      } finally {
        setLoading(false);
      }
    };
  
    fetchMaterias();
  }, [navigate]);
  
  // Finalmente el return con el JSX
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }
  const handlePdfDownload = async () => {
    try {
      setIsSending(true);
      const documento = localStorage.getItem('documento');
  
      const periodResponse = await fetch(endpoints.periodoActivo);
      if (!periodResponse.ok) throw new Error('Error al obtener el período activo');
      
      const periodData = await periodResponse.json();
      if (!periodData.existe) throw new Error('No hay período activo');
  
      const pdfResponse = await fetch(
        endpoints.generarPdf(documento),
        { method: 'GET' }
      );
  
      if (!pdfResponse.ok) throw new Error('Error al generar el PDF');
  
      // Download PDF
      const blob = await pdfResponse.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `matricula_${documento}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error:', error);
      setError('No se pudo generar el PDF. Inténtalo nuevamente.');
    } finally {
      setIsSending(false);
    }
  };
  // Finalmente el return con el JSX
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
      </div>
    );
  }
  
  return (
    <>
      <Navbar />
      <div className="bg-gray-100 min-h-screen p-8">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            Materias Matriculadas
          </h1>
          <h2 className="text-lg text-gray-600 mb-6">
            <span className="font-bold">{programaInfo.nombre}</span>
          </h2>
  
          {error && (
            <div className="p-4 mb-4 text-red-700 bg-red-100 rounded">
              {error}
            </div>
          )}
  
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-300">
              <thead>
                <tr className="bg-gray-100">
                  <th className="py-2 px-4 border-b">#</th>
                  <th className="py-2 px-4 border-b">Materia</th>
                  <th className="py-2 px-4 border-b">Grupo</th>
                </tr>
              </thead>
              <tbody>
                {materias.map((materia) => (
                  <tr key={materia.numero} className="hover:bg-gray-50">
                    <td className="py-2 px-4 border-b text-center">{materia.numero}</td>
                    <td className="py-2 px-4 border-b">{materia.nombre}</td>
                    <td className="py-2 px-4 border-b text-center">{materia.grupo}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
  
          <div className="mt-6 space-y-4">
            <div className="flex space-x-4">
              <button
                type="button"
                onClick={() => handleAcuerdoChange('acepto')}
                className={`flex-1 py-2 px-4 rounded-md font-medium ${
                  isSending ? 'bg-gray-400 cursor-not-allowed' :
                  acuerdo === 'acepto'
                    ? 'bg-green-600 text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-green-500 hover:text-white'
                }`}
              >
                {isSending ? 'Procesando...' : 'Acepto'}
              </button>
              <button
                type="button"
                onClick={() => handleAcuerdoChange('noAcepto')}
                className={`flex-1 py-2 px-4 rounded-md font-medium ${
                  acuerdo === 'noAcepto'
                    ? 'bg-red-600 text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-red-500 hover:text-white'
                }`}
              >
                {isSending ? 'Procesando...' : 'No Acepto'}
              </button>
            </div>
  
            {showModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                <div className="bg-white rounded-lg p-6 w-full max-w-md">
                  <h3 className="text-lg font-bold mb-4">Por favor, ingrese su observación</h3>
                  <textarea
                    value={observacion}
                    onChange={(e) => setObservacion(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md mb-4"
                    rows="4"
                    placeholder="Escriba aquí su observación..."
                    required
                  />
                  <div className="flex justify-end space-x-2">
                    <button
                      type="button"
                      onClick={() => {
                        setShowModal(false);
                        setAcuerdo('');
                      }}
                      className="px-4 py-2 text-gray-600 hover:text-gray-800"
                    >
                      Cancelar
                    </button>
                    <button
                      type="button"
                      onClick={handleObservacionSubmit}
                      disabled={isSending}
                      className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-400"
                    >
                      {isSending ? 'Enviando...' : 'Enviar'}
                    </button>
                  </div>
                </div>
              </div>
            )}
  
            {!showModal && acuerdo && (
              <button
                onClick={handlePdfDownload}
                disabled={isSending}
                className="w-max bg-neutral-900 text-white px-4 py-2 rounded-md font-medium hover:bg-neutral-800 disabled:bg-gray-400"
              >
                {isSending ? 'Descargando PDF...' : 'Descargar PDF'}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default VerMatricula;